module.exports = __webpack_public_path__ + "assets/img/btn-view-fe1f6566.png";